module.exports = __webpack_public_path__ + "static/media/team2.3ba1b726.png";